import { HELPS_PHONE } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';
import Icon from './Icon';

/** Primary call-to-action pair. The call button only renders once a phone number is configured. */
export default function ContactActions({ chatLabel = 'Start Live Chat', light = false, className = '' }) {
  return (
    <div className={`actions ${className}`.trim()}>
      <button type="button" className="btn btn--primary" onClick={openZohoChat}>
        <Icon name="chat" size={20} /> {chatLabel}
      </button>
      {HELPS_PHONE ? (
        <a href={HELPS_PHONE.tel} className={`btn ${light ? 'btn--ghost-light' : 'btn--ghost'}`}>
          <Icon name="phone" size={20} /> {HELPS_PHONE.display}
        </a>
      ) : null}
    </div>
  );
}
